module.exports = __webpack_public_path__ + "img/Photo_4___People_&_Pleasures_Boat_excursion_2009_20_81.1bfb04c0.jpg";